import { render, staticRenderFns } from "./Salesman.vue?vue&type=template&id=6ff3745d"
import script from "./Salesman.vue?vue&type=script&lang=js"
export * from "./Salesman.vue?vue&type=script&lang=js"
import style0 from "./Salesman.vue?vue&type=style&index=0&id=6ff3745d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports